import React from 'react'

import {
  createColumnHelper,
  getCoreRowModel,
  useReactTable,
} from '@tanstack/react-table'
import { useTranslation } from 'react-i18next'

import {
  Box,
  DataTable,
  Flex,
  Text,
  Tooltip,
} from '@enechain/ecloud-designsystem'
import { FaCircleQuestionRegular } from '@enechain/ecloud-icons'
import { getTextAlignLightTableStyle } from '@enechain/eposition-ui'

import { MarginSimulationResultForOption1Models } from '~/pages/Simulation/models/SimulationResultModel/MarginSimulationResultForOption1Models'
import { ResultSimulationForOption1Model } from '~/pages/Simulation/models/SimulationResultModel/ResultSimulationForOption1Model'

type Props = {
  resultDetail: MarginSimulationResultForOption1Models | undefined
}

export const MarginSimulationTableForOption1: React.FC<Props> = ({
  resultDetail,
}) => {
  const { t } = useTranslation(['page', 'common', 'domain'])
  const columnHelper = createColumnHelper<ResultSimulationForOption1Model>()

  const columns = [
    columnHelper.accessor('relationNumber', {
      header: t('page:simulation.relation_number'),
      cell: (info) => <Box>{info.getValue()}</Box>,
      enableSorting: false,
      meta: {
        headerStyle: {
          borderRight: `2px solid {colors.Border.midEmphasis}`,
        },
        cellStyle: {
          borderRight: `2px solid {colors.Border.midEmphasis}`,
        },
      },
    }),
    columnHelper.accessor('requiredMarginAmount', {
      header: t('page:simulation.required_margin'),
      cell: (info) => <Box>{info.getValue()}</Box>,
      enableSorting: false,
      meta: getTextAlignLightTableStyle(),
    }),
    columnHelper.accessor('surplusAmount', {
      header: () => (
        <Flex justifyContent="flex-end" alignItems="center" gap="1">
          <Text>{t('page:simulation.surplus_or_deficit')}</Text>
          <Tooltip
            label={t('page:simulation.surplus_or_deficit_description')}
            showArrow
            placement="top"
          >
            <FaCircleQuestionRegular boxSize="20px" />
          </Tooltip>
        </Flex>
      ),
      cell: (info) => <Box>{info.getValue()}</Box>,
      enableSorting: false,
      meta: getTextAlignLightTableStyle(),
    }),
  ]

  const table = useReactTable({
    data: resultDetail?.details ?? [],
    columns,
    getCoreRowModel: getCoreRowModel(),
  })

  return (
    <DataTable
      table={table}
      emptyComponent={
        <Box width="100%" textAlign="center">
          {t('common:error.empty_data')}
        </Box>
      }
    />
  )
}
